// App settings from env files (Vue CLI): only VUE_APP_* variables reach the bundle, and they
// are baked in at BUILD time, not read at runtime. Everything here ends up in public JS:
// never put secrets into these variables.
//
//   .env.example      the list of variables (copy to .env.local for local development)
//   .env.local        local overrides, git-ignored
//   .env              written by CI from the ENV_FILE variable before the production build
//
// Defaults below keep `npm run serve` working without any env file.
const env = process.env;

export default {
    locale: env.VUE_APP_LOCALE || 'ru',
    baseUrl: env.VUE_APP_BASE_URL || 'http://localhost:8090',
    siteTitle: env.VUE_APP_SITE_TITLE || 'testing',
    noAvatarUrl: env.VUE_APP_NO_AVATAR_URL || '/images/img_avatar-defaut.svg',
    noProfilePhotoUrl: env.VUE_APP_NO_PROFILE_PHOTO_URL || '/images/no_profile_photo_user.png',
};
